import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import {
    SvgIconGrupoCoberturaSeguroVidaMorte,
    SvgIconGrupoCoberturaSeguroVidaInvalidezAcidente,
    SvgIconGrupoCoberturaSeguroVidaInvalidezDoenca,
    SvgIconGrupoCoberturaSeguroVidaDoencasGraves,
    SvgIconGrupoCoberturaSeguroVidaIncapacidadeTemporaria,
    SvgIconGrupoCoberturaSeguroVidaFuneral,
    SvgIconGrupoCoberturaSeguroVidaAssistencia,
} from '../../../business-components/SvgIcon/SvgIconSeguroVida/SvgIconSeguroVida'

import {
    StepperPadrao
} from '../../../business-components/Stepper/Stepper'

import {
    grupoCoberturaSeguroVida1aParteList,
    grupoCoberturaSeguroVida2aParteList,
} from '../../../business-rules/List/SeguroVida/grupoCoberturaSeguroVidaList'

 import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import SeguroVidaPropostaFormProposta from './SeguroVidaPropostaFormProposta'

import {
    processaRegistrosDefaultIniciaisSeguroVidaProposta,
//    calculaTotaisSeguroVidaProposta,
} from './SeguroVidaPropostaService'



const SeguroVidaPropostaForm = ({ variaveisGlobais, values, handleChange, setFieldValue, vars, arquivoList }) => {

    const stepsSvgIcon = [
        SvgIconGrupoCoberturaSeguroVidaMorte,
        SvgIconGrupoCoberturaSeguroVidaInvalidezAcidente,
        SvgIconGrupoCoberturaSeguroVidaInvalidezDoenca,
        SvgIconGrupoCoberturaSeguroVidaDoencasGraves,
        SvgIconGrupoCoberturaSeguroVidaIncapacidadeTemporaria,
        SvgIconGrupoCoberturaSeguroVidaFuneral,
        SvgIconGrupoCoberturaSeguroVidaAssistencia,
    ]

    let steps = []

    grupoCoberturaSeguroVida1aParteList?.forEach( (linhaGrupoCoberturaSeguroVida1aParteList, index) => {
        
        steps.push(linhaGrupoCoberturaSeguroVida1aParteList)
    })

    steps[0] = LABEL.morteAcidental

    const stepsTitle2 = grupoCoberturaSeguroVida2aParteList

    const stepsContent = [
        <SeguroVidaPropostaFormProposta
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaPropostaFormProposta
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaPropostaFormProposta
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaPropostaFormProposta
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaPropostaFormProposta
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaPropostaFormProposta
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaPropostaFormProposta
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
    ]

    const valuesStepsTitle2 = [
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
    ]

//    calculaTotaisSeguroVidaProposta(values)

    return (
        <>
            <PanelRadioGroup
                name="familiarSeguroVidaProposta"
                value={Number.parseInt(values.familiarSeguroVidaProposta) || ''}
                onChange={(e) => {
                    handleChange(e)
                }}
                list={values.totalSeguroVidaProposta}
                onBlur={
                    processaRegistrosDefaultIniciaisSeguroVidaProposta(values,
                        Number.parseInt(values.familiarSeguroVidaProposta))
                }
                helpText={HELPTEXT.seguroVidaPropostaPanelRadioGroup}
            />

            <StepperPadrao
                stepsType={"cardValor"}
                stepsSvgIcon={stepsSvgIcon}
                steps={steps}
                stepsTitle2={stepsTitle2}
                stepsContent={stepsContent}
                valuesStep={values.stepSeguroVidaProposta}
                valuesStepsValor={values.stepsValorSeguroVidaProposta}
                valuesStepsTitle2={valuesStepsTitle2}
                valuesStepsValor2={values.stepsValor2SeguroVidaProposta}
                naoPermiteConcluir={true}
            />
        </>
    )
}

export default SeguroVidaPropostaForm